import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Col, Row} from 'react-bootstrap';
import  france_tv_on  from 'assets/pics/france_tv_pro_blanc.png';
import './Footer.css'; 


const Footer = observer(
  class Footer extends Component {
	
		state = {baba:'dudu'};
		

			
    render() {
			return  (
				<Row className="blackfootrow">
					<Col xs={2}></Col>
					<Col xs={8}  className="tac">
						<a href="#" onClick={this.props.openmenleg}	>mentions légales</a>
						<span className="ball_divisor">⚫</span>
						<a href="/gdpr" target="_blank">CGU</a>
						<span className="ball_divisor">⚫</span>
						<a href="https://www.francetelevisions.fr/confidentialite#politique-confidentialite" target="_blank">politique de confidentialité</a>
						<span className="ball_divisor">⚫</span>
						<a href="http://www.francetvpro.fr/" target="_blank"><img src={france_tv_on} /></a>
					</Col>
					<Col className="copycol" xs={2}> © {new Date().getFullYear()} France Télévisions</Col>
				</Row>
			)
    }
		
		
		
  }
)


export default Flow.injectFlow(Footer);